import JoditEditor, { IJoditEditorProps } from "jodit-react";
import { useRef, useEffect, useState, useMemo } from "react";
import { debounce } from "lodash";
import callApi from "Common/utils/apiCaller";

interface HtmlCodeProps {
  content: string;
  setContent: (content: string) => void;
  label?: string;
  placeholder?: string;
}

const HtmlCode: React.FC<HtmlCodeProps> = ({
  content,
  setContent,
  label,
  placeholder = "start typing text",
}) => {
  const editor = useRef(null);

  const handleContentChange = (newContent: any) => {
    if (typeof newContent === "string") {
      setContent(newContent);
    } else {
      setContent("");
    }
  };

  const config = useMemo(
    () => ({
      readonly: false,
      height: "300px",
      uploader: {
        insertImageAsBase64URI: true,
      },
      placeholder: placeholder || "Start typing here...",
      buttons: [
        "bold",
        "italic",
        "underline",
        "|",
        "ul",
        "ol",
        "|",
        "outdent",
        "indent",
        "|",
        "image",
        "|",
        "align",
        "undo",
        "redo",
        "|",
        "hr",
        "eraser",
        "fullsize",
      ],
      removeButtons: [],
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: true,
      askBeforePasteFromWord: true,
      defaultActionOnPaste: "insert_clear_html" as const,
      tabIndex: 1,
      statusbar: false,
      toolbar: true,
      theme: "default",
      zIndex: 0,
    }),
    [placeholder]
  );

  // Ensure content is always a string and handle null/undefined cases
  const safeContent = useMemo(() => {
    if (content === null || content === undefined) return "";
    return String(content);
  }, [content]);

  return (
    <>
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
        <div className="xl:col-span-12">
          <label
            htmlFor="phoneNumberIn"
            className="inline-block mb-2 text-base font-medium"
          >
            {label}
          </label>
          <JoditEditor
            ref={editor}
            value={safeContent}
            config={config}
            onBlur={handleContentChange}
          />
        </div>
      </div>
    </>
  );
};

export default HtmlCode;
